import LoadingAndMessageModal from "./LoadingAndMessageModal";

export default LoadingAndMessageModal;
